let hasWarned = false;
const hostname = window.location.hostname;
const parts = hostname.split('.');
const href = parts.length > 2 ? parts[0] : hostname; // Subdomain (DEV, COMALTX, etc) or hostname (full domain)

export let FUSION_PREFIX = '/fusion/';
export let TEAM_PREFIX = '';
export let CUSTOM_URL;

if (hostname.includes('localhost')) {
  CUSTOM_URL = 'https://devapi.overwatch.ai';
  TEAM_PREFIX = '/dev';
} else if (hostname.includes('192')) {
  CUSTOM_URL = 'https://devapi.overwatch.ai';
  TEAM_PREFIX = '/dev';
} else if (href === 'devdemo') {
  CUSTOM_URL = 'https://devapi.overwatch.ai';
  TEAM_PREFIX = '/dev';
} else if (href === 'staging') {
  CUSTOM_URL = 'https://aggapi.overwatch.ai';
  TEAM_PREFIX = '/staging';
} else if (href === 'demo') {
  CUSTOM_URL = 'https://aggapi.overwatch.ai';
  TEAM_PREFIX = '/demo';
} else {
  CUSTOM_URL = 'https://aggapi.overwatch.ai';
  TEAM_PREFIX = '/' + href;
}

export function _Environment() {
  if (process.env.NODE_ENV === 'development') {
    if (!hasWarned) {
      hasWarned = true;
    }
  }

  return href.toUpperCase();
}
